import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "./UserContext";
import { useNavigate } from 'react-router-dom';
import TestataAdmin from "./partials/TestataAdmin";
import Footer from "./partials/Footer";

function UtenteAdminNew() {
  const { userData } = useContext(UserContext);
  const navigate = useNavigate();
  // const [utente, setUtente] = useState(null);
  const [generatedPassword, setGeneratedPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // Stato per mostrare/nascondere la password
  const generateRandomPassword = (length = 12) => {
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%()_-+=[]./?";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
    };

  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    ragSociale: "",
    role: "",
    mail: "",
    password: generateRandomPassword(),
    attivo: false,
    indirizzo: "",
    comune: "",
    prov: "",
    cap: "",
    regione: "",
    tel: "",
    cell: "",
    url: "",
    codFisc: "",
    piva: ""
  });
  const [error, setError] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); 
  // Definizione della funzione fetchCliente FUORI da useEffect
  
  const province = [
    { sigla: 'AG', nome: 'Agrigento' },
    { sigla: 'AL', nome: 'Alessandria' },
    { sigla: 'AN', nome: 'Ancona' },
    { sigla: 'AO', nome: 'Aosta' },
    { sigla: 'AR', nome: 'Arezzo' },
    { sigla: 'AP', nome: 'Ascoli Piceno' },
    { sigla: 'AT', nome: 'Asti' },
    { sigla: 'AV', nome: 'Avellino' },
    { sigla: 'BA', nome: 'Bari' },
    { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
    { sigla: 'BL', nome: 'Belluno' },
    { sigla: 'BN', nome: 'Benevento' },
    { sigla: 'BG', nome: 'Bergamo' },
    { sigla: 'BI', nome: 'Biella' },
    { sigla: 'BO', nome: 'Bologna' },
    { sigla: 'BZ', nome: 'Bolzano' },
    { sigla: 'BS', nome: 'Brescia' },
    { sigla: 'BR', nome: 'Brindisi' },
    { sigla: 'CA', nome: 'Cagliari' },
    { sigla: 'CL', nome: 'Caltanissetta' },
    { sigla: 'CB', nome: 'Campobasso' },
    { sigla: 'CI', nome: 'Carbonia-Iglesias' },
    { sigla: 'CE', nome: 'Caserta' },
    { sigla: 'CT', nome: 'Catania' },
    { sigla: 'CZ', nome: 'Catanzaro' },
    { sigla: 'CH', nome: 'Chieti' },
    { sigla: 'CO', nome: 'Como' },
    { sigla: 'CS', nome: 'Cosenza' },
    { sigla: 'CR', nome: 'Cremona' },
    { sigla: 'KR', nome: 'Crotone' },
    { sigla: 'CN', nome: 'Cuneo' },
    { sigla: 'EN', nome: 'Enna' },
    { sigla: 'FM', nome: 'Fermo' },
    { sigla: 'FE', nome: 'Ferrara' },
    { sigla: 'FI', nome: 'Firenze' },
    { sigla: 'FG', nome: 'Foggia' },
    { sigla: 'FC', nome: 'Forlì-Cesena' },
    { sigla: 'FR', nome: 'Frosinone' },
    { sigla: 'GE', nome: 'Genova' },
    { sigla: 'GO', nome: 'Gorizia' },
    { sigla: 'GR', nome: 'Grosseto' },
    { sigla: 'IM', nome: 'Imperia' },
    { sigla: 'IS', nome: 'Isernia' },
    { sigla: 'SP', nome: 'La Spezia' },
    { sigla: 'AQ', nome: "L'Aquila" },
    { sigla: 'LT', nome: 'Latina' },
    { sigla: 'LE', nome: 'Lecce' },
    { sigla: 'LC', nome: 'Lecco' },
    { sigla: 'LI', nome: 'Livorno' },
    { sigla: 'LO', nome: 'Lodi' },
    { sigla: 'LU', nome: 'Lucca' },
    { sigla: 'MC', nome: 'Macerata' },
    { sigla: 'MN', nome: 'Mantova' },
    { sigla: 'MS', nome: 'Massa-Carrara' },
    { sigla: 'MT', nome: 'Matera' },
    { sigla: 'ME', nome: 'Messina' },
    { sigla: 'MI', nome: 'Milano' },
    { sigla: 'MO', nome: 'Modena' },
    { sigla: 'MB', nome: 'Monza e della Brianza' },
    { sigla: 'NA', nome: 'Napoli' },
    { sigla: 'NO', nome: 'Novara' },
    { sigla: 'NU', nome: 'Nuoro' },
    { sigla: 'OG', nome: 'Ogliastra' },
    { sigla: 'OT', nome: 'Olbia-Tempio' },
    { sigla: 'OR', nome: 'Oristano' },
    { sigla: 'PD', nome: 'Padova' },
    { sigla: 'PA', nome: 'Palermo' },
    { sigla: 'PR', nome: 'Parma' },
    { sigla: 'PV', nome: 'Pavia' },
    { sigla: 'PG', nome: 'Perugia' },
    { sigla: 'PU', nome: 'Pesaro e Urbino' },
    { sigla: 'PE', nome: 'Pescara' },
    { sigla: 'PC', nome: 'Piacenza' },
    { sigla: 'PI', nome: 'Pisa' },
    { sigla: 'PT', nome: 'Pistoia' },
    { sigla: 'PN', nome: 'Pordenone' },
    { sigla: 'PZ', nome: 'Potenza' },
    { sigla: 'PO', nome: 'Prato' },
    { sigla: 'RG', nome: 'Ragusa' },
    { sigla: 'RA', nome: 'Ravenna' },
    { sigla: 'RC', nome: 'Reggio Calabria' },
    { sigla: 'RE', nome: 'Reggio Emilia' },
    { sigla: 'RI', nome: 'Rieti' },
    { sigla: 'RN', nome: 'Rimini' },
    { sigla: 'RM', nome: 'Roma' },
    { sigla: 'RO', nome: 'Rovigo' },
    { sigla: 'SA', nome: 'Salerno' },
    { sigla: 'VS', nome: 'Medio Campidano' },
    { sigla: 'SS', nome: 'Sassari' },
    { sigla: 'SV', nome: 'Savona' },
    { sigla: 'SI', nome: 'Siena' },
    { sigla: 'SR', nome: 'Siracusa' },
    { sigla: 'SO', nome: 'Sondrio' },
    { sigla: 'TA', nome: 'Taranto' },
    { sigla: 'TE', nome: 'Teramo' },
    { sigla: 'TR', nome: 'Terni' },
    { sigla: 'TO', nome: 'Torino' },
    { sigla: 'TP', nome: 'Trapani' },
    { sigla: 'TN', nome: 'Trento' },
    { sigla: 'TV', nome: 'Treviso' },
    { sigla: 'TS', nome: 'Trieste' },
    { sigla: 'UD', nome: 'Udine' },
    { sigla: 'VA', nome: 'Varese' },
    { sigla: 'VE', nome: 'Venezia' },
    { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' },
    { sigla: 'VC', nome: 'Vercelli' },
    { sigla: 'VR', nome: 'Verona' },
    { sigla: 'VV', nome: 'Vibo Valentia' },
    { sigla: 'VI', nome: 'Vicenza' },
    { sigla: 'VT', nome: 'Viterbo' },
  ];
  
  useEffect(() => {
    // Genera una password casuale al caricamento del componente
    setGeneratedPassword(generateRandomPassword());
  }, []); // Esegui solo una volta al montaggio del componente

  const handleChangePassword = (e) => {
    setGeneratedPassword(e.target.value);
    setFormData({ ...formData, password: e.target.value });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeBool = (e) => {
    const { name, checked } = e.target; // Ottieni il valore checked (booleano)
    setFormData({ ...formData, [name]: checked }); // Aggiorna lo stato con il valore booleano
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    
    try {
      const token = localStorage.getItem('token');
      // // Crea un nuovo FormData e aggiungi tutti i campi necessari
      // const formDataToSend = new FormData();
      // for (const key in formData) {
      //   formDataToSend.append(key, formData[key]);
      // }
      const response = await fetch(`/api/nuovo-utente`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify(formData),
      });
      if (response.status === 201) {      
        setShowSuccessMessage(true);
        // Nascondi il messaggio dopo un breve ritardo (opzionale)
        setTimeout(() => {
        setShowSuccessMessage(false);
        }, 3000); // Nascondi dopo 3 secondi
        navigate('/amministratore/utenti'); // Reindirizza alla dashboard dopo l'upload
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Errore durante il salvataggio');
        setTimeout(() => {
            error(false);
        }, 3000); // Nascondi dopo 3 secondi
      }
    } catch (err) {
      console.error('Errore durante il salvataggio:', err);
      setError('Si è verificato un errore durante il salvataggio');
        setTimeout(() => {
            error(false);
        }, 3000); // Nascondi dopo 3 secondi
    }
  };

  return (
    <>
      <section className="main_content dashboard_part">
        <div className='className="container-fluid g-0'>            
            <TestataAdmin userData={userData} />
        </div>
        <div className="main_content_iner ">
          <div className="container-fluid plr_30 body_white_bg pt_30">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="white_box_tittle list_header">
                  <h4>Nuova Attività/Utente</h4>
                </div>                
                  <form onSubmit={handleSubmit}>
                    <div className="col-12 mb_30">
                      <div className="row">
                        <div className="form-group col-md-1 cols-sm-6 mb_20">
                            <label htmlFor="role">Amministratore:</label><br />
                            <input
                                type="checkbox"
                                id="role"
                                name="role"
                                checked={formData.role}
                                value="true"
                                onChange={handleChangeBool}                                
                            />
                        </div>          
                        <div className="form-group col-md-1 cols-sm-6 mb_20">
                            <label htmlFor="ragioneSociale">Attivo:</label><br />
                            <input
                                type="checkbox"
                                id="attivo"
                                name="attivo"
                                checked={formData.attivo}
                                value="true"
                                onChange={handleChangeBool}                                
                            />
                        </div>               
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="ragioneSociale">Ragione Sociale <b style={{color: "#CC0000"}}>*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="ragSociale"
                                name="ragSociale"
                                value={formData.ragSociale}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group col-md-3 cols-sm-12 mb_20">
                            <label htmlFor="nome">Nome:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nome"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}                                
                            />
                        </div>
                        <div className="form-group col-md-3 cols-sm-12 mb_20">
                            <label htmlFor="cognome">Cognome:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cognome"
                                name="cognome"
                                value={formData.cognome}
                                onChange={handleChange}                                
                            />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6 cols-sm-12 mb_20">
                            <label htmlFor="indirizzo">Indirizzo <b style={{color: "#CC0000"}}>*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="indirizzo"
                                name="indirizzo"
                                value={formData.indirizzo}
                                onChange={handleChange}                                
                            />
                        </div>
                      
                        <div className="form-group col-md-6 cols-sm-12 mb_20">
                          <label htmlFor="comune">Comune <b style={{color: "#CC0000"}}>*</b>:</label>
                          <input
                              type="text"
                              className="form-control"
                              id="comune"
                              name="comune"
                              value={formData.comune}
                              onChange={handleChange}                            
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6 cols-sm-12 mb_20">
                          <label htmlFor="comune">Regione <b style={{color: "#CC0000"}}>*</b>:</label>
                          <input
                              type="text"
                              className="form-control"
                              id="regione"
                              name="regione"
                              value={formData.regione}
                              onChange={handleChange}                            
                          />
                        </div>
                        <div className="form-group col-md-3 cols-sm-6 mb_20">
                            <label htmlFor="prov">Prov <b style={{color: "#CC0000"}}>*</b>:</label>
                            <select
                              className="form-select form-control"
                              id="prov"
                              name="prov"
                              value={formData.prov} // Imposta il valore in maiuscolo
                              onChange={handleChange}
                            >
                              {province.map(provincia => (
                                <option key={provincia.sigla} value={provincia.sigla}>
                                  {provincia.nome.charAt(0) + provincia.nome.slice(1)}
                                </option>
                              ))}
                            </select>
                        </div>
                        <div className="form-group col-md-3 cols-sm-6 mb_20">
                            <label htmlFor="cap">CAP <b style={{color: "#CC0000"}}>*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cap"
                                name="cap"
                                value={formData.cap}
                                onChange={handleChange}                                
                            />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="tel">Telefono:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tel"
                                name="tel"
                                value={formData.tel}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="cell">Cellulare:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cell"
                                name="cell"
                                value={formData.cell}
                                onChange={handleChange}                                
                            />
                        </div>     
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="sitoweb">Sito web &nbsp; [http(s)://nomeazienda.ext]:</label><br />
                            <input
                                type="text"
                                className="form-control"
                                id="url"
                                name="url"
                                value={formData.url}
                                onChange={handleChange}
                            />
                        </div>                      
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="mail">Indirizzo e-mail/Nome Utente <b style={{color: "#CC0000"}}>*</b>:</label>
                            <input
                                type="mail"
                                className="form-control"
                                id="mail"
                                name="mail"
                                value={formData.mail}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group col-md-2 cols-sm-12 mb_20 position-relative">
                            <label htmlFor="password">Password <b style={{color: "#CC0000"}}>*</b>:</label>
                            <div className="input-group input-group mb-3">
                                <input
                                    type={showPassword ? "text" : "password"} 
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChangePassword}                                       
                                />
                                <div className="input-group-text">
                                    <span className="" id="inputGroup-sizing-sm">
                                        <button type="button" style={{padding: '0', border: '0px solid transparent'}} onClick={() => setShowPassword(!showPassword)}>
                                            <i className={showPassword ? "ti-lock" : "ti-eye"}></i> {/* Icone Themify */}                                        
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>                         
                    
                        <div className="form-group col-md-3 cols-sm-12 mb_20">
                            <label htmlFor="codFisc">Codice Fiscale <b style={{color: "#CC0000"}}>*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="codFisc"
                                name="codFisc"
                                value={formData.codFisc}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group col-md-3 cols-sm-12 mb_20">
                            <label htmlFor="piva">Partita IVA <b style={{color: "#CC0000"}}>*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="piva"
                                name="piva"
                                value={formData.piva}
                                onChange={handleChange}                                
                            />
                        </div> 
                    </div>
                    <div className="row">                     
                      <div className="form-group col-md-12 cols-sm-12 mb_20" style={{textAlign: 'right'}}>
                        {showSuccessMessage && ( // Mostra il messaggio solo se showSuccessMessage è true
                          <div className="alert alert-success mt_20" role="alert">Dati aggiornati con successo!</div>
                        )}
                        {error && <div className="alert alert-danger mt_20" role="alert">{error}</div>}
                          <button type="submit" className="btn btn-primary mt_20">Aggiungi Utente</button>
                      </div>
                    </div>
                  </div>
                </form>                
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default UtenteAdminNew;
